import gql from 'graphql-tag'

export const eventsQuery = gql`
  query eventsQuery($userId: ID!, $dayS: DateTime, $dayE: DateTime) {
    allEvents(
      filter: {
        AND: [
          { user: { id: $userId } }
          {
            OR: [
              { AND: [{ startedAt_gte: $dayS }, { startedAt_lte: $dayE }] }
              { AND: [{ completedAt_gte: $dayS }, { completedAt_lte: $dayE }] }
            ]
          }
        ]
      }
    ) {
      id
      minutes
      startedAt
      completedAt
      eventType
      dataOrigin
      options
      mood
      comment
      tracker {
        id
        name
        category
        isDuration
        isStared
        color
        type
      }
      book {
        id
        name
      }
      bookPref {
        id
        maxPage
        percentRead
      }
      task {
        id
        name
      }
      subtask {
        id
        name
      }
    }
  }
`

export const eventsQueryAgg = gql`
  query eventsQueryAgg($userId: ID!, $dayS: DateTime, $dayE: DateTime) {
    allEvents(
      filter: {
        AND: [
          { user: { id: $userId } }
          {
            OR: [
              { AND: [{ startedAt_gte: $dayS }, { startedAt_lte: $dayE }] }
              { AND: [{ completedAt_gte: $dayS }, { completedAt_lte: $dayE }] }
            ]
          }
          { eventType_contains: "happened" }
          { minutes_gt: 0 }
          { tracker: { type_not: "sleep" } }
        ]
      }
    ) {
      id
      completedAt
      minutes
      tracker {
        id
        name
        category
        color
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/graphql/queries/event.js